<template>
  <v-card class="item" color="white" :to="to" flat>
    <img
      @error="onError"
      class="d-block rounded-lg item-img"
      :src="files + img + '?resize=1&w=360'"
      :alt="title"
    />

    <div class="pt-2 pb-4 px-3 item-content">
      <div
        class="
          grey--text
          text--darken-4 text-body-1 text-md-subtitle-1
          font-weight-bold
          item-title
        "
      >
        {{ title }}
      </div>
      <div
        class="grey--text text--darken-4 text-caption font-weight-medium mt-1"
      >
        {{
          formatDate(date, { day: "numeric", month: "long", year: "numeric" })
        }}
      </div>
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";
import { formatDate } from "../../utils/formatDate";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 340 / 200;
    object-fit: cover;
    width: 100%;
  }
}
</style>
